import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/modals/actions';
import ReduxModal from 'Common/Components/ReduxModal';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import { Lock } from './styled';

// Community-only fallback for EEFeatureSlot: renders instead of a real Enterprise
// Edition feature when src/ee/ isn't present, so the feature stays discoverable
// (per product decision) instead of disappearing. Reuses the existing
// UpgradeLicense modal pattern already used by the Sidebar/UpgradeLicense/
// HostsLimitReached components.
const EELockedFeature = ({
  modalId, image, descriptionIntlId, title, icon: Icon
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Icon title={ title } onClick={ () => dispatch(openModal(modalId)) } />
      <ReduxModal id={ modalId }>
        <UpgradeLicense id={ modalId } image={ image } descriptionIntlId={ descriptionIntlId } />
      </ReduxModal>
    </>
  );
};

EELockedFeature.propTypes = {
  modalId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  descriptionIntlId: PropTypes.string.isRequired,
  title: PropTypes.string,
  icon: PropTypes.elementType
};

EELockedFeature.defaultProps = {
  title: '',
  icon: Lock
};

export default EELockedFeature;
